export default {
  support: {
    support: 'Apoyo',
    requestFeature: 'Solicitar una característica',
    reportBug: 'Reportar un error',
    topic: 'Tema',
    description: 'Descripción',
    addScreenshot: 'Agregar una captura de pantalla (opcional)',
    towOrder: 'Orden de Remolque',
    dispatch: 'Despacho',
    thankYouForYourFeedback: '¡Gracias por tus comentarios!',
    weAppreciateYourPartnership: 'Agradecemos su colaboración',
    couldNotSubmitRequest: 'Desafortunadamente, no pudimos enviar su solicitud.',
    submit: 'Entregar'
  },
};
